@let _categoryData = categoryData();

@if (_categoryData) {
  <sd-sibling-categories
    [siblingCategories]="siblingCategories"
    [currentCategoryName]="_categoryData?.name"
    (siblingCategoryIsClicked)="onClickSiblingCategory($event)"
    data-testid="sibCategories"
  />
}